var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "question-box-radio-button" },
    [
      _c("p", { staticClass: "question-box-radio-button__question-label" }, [
        _vm._v(" " + _vm._s(_vm.label) + " ")
      ]),
      _c(
        "div",
        { staticClass: "question-box-radio-button__question-group" },
        _vm._l(_vm.localOptions, function(option, index) {
          return _c(
            "div",
            {
              key: `question-box-radio-button__question-${
                option.label
              }-${index}-${Math.random()}`,
              staticClass: "question-box-radio-button__answer",
              class: {
                "question-box-radio-button__answer--checked": option.check,
                "question-box-radio-button__answer--invalid": _vm.error
              },
              on: {
                click: function($event) {
                  return _vm.selectOption(option, index)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "question-box-radio-button__answer__wrapper-radio"
                },
                [
                  _c(
                    "span",
                    { staticClass: "question-box-radio-button__answer__radio" },
                    [
                      _c("input", {
                        staticClass:
                          "question-box-radio-button__answer__radio__input",
                        attrs: {
                          name: `question-box-radio-button__answer__${_vm.label}`,
                          type: "radio"
                        },
                        domProps: { checked: option.check }
                      })
                    ]
                  ),
                  _c("i", {
                    staticClass:
                      "question-box-radio-button__answer__radio-mark fas fa-circle"
                  })
                ]
              ),
              _c(
                "label",
                {
                  staticClass: "question-box-radio-button__answer__label",
                  attrs: {
                    for: `question-box-radio-button__answer__${_vm.label}`
                  }
                },
                [_vm._v(" " + _vm._s(option.label) + " ")]
              )
            ]
          )
        }),
        0
      ),
      _vm.localOptions && _vm.error
        ? _c("error", {
            attrs: { message: _vm.customErrorMsg, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }